import type { DepartmentJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectDepartment extends IkeRestObject<DepartmentJSONObject> {
	className = 'Department' as const;
	actionName = 'department';
	object: DepartmentJSONObject;
}
